import React from 'react';
import ReactDOM from 'react-dom';
import Routes from '~/routes';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals';
import './styles';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <React.StrictMode>
    <Routes />
    <ToastContainer />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
